import { render, staticRenderFns } from "./BabyCard.vue?vue&type=template&id=0c86dc39"
import script from "./BabyCard.vue?vue&type=script&lang=js"
export * from "./BabyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports